<template>
  <el-dropdown @command="handleCommand">
     <span class="el-dropdown-link">
       {{ $t('parking.download_report') }}<i class="el-icon-arrow-down el-icon--right"></i>
     </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="csv">.CSV</el-dropdown-item>
      <el-dropdown-item command="xlsx" divided>.XLSX</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: 'ReportDownloadDropdown',
  methods: {
    handleCommand(command) {
      this.$emit('reportFormat', command);
    }
  }
};
</script>

<style lang="scss" scoped>

@import '../../styles/app';

.el-dropdown-link {
  color: var(--white);
  font-size: 18px;
}
.el-icon-arrow-down {
  font-size: 18px;
}

</style>



// WEBPACK FOOTER //
// src/components/parkings/ReportDownloadDropdown.vue